import type { FC } from "react";

export const DownloadIcon: FC = () => {
  return (
    <svg
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
    >
      <path d="M11.962 7.442l-.712-.7L8.36 9.69V1.975h-1V9.69L4.472 6.742l-.715.7L7.86 11.63l4.102-4.188zm1.395 5.556H2.477v1h10.88v-1z"></path>
    </svg>
  );
};
